import { h, Component } from 'preact'
import Headline from '../components/Headline'
import Product from '../components/Product'
import ColorDot from '../components/ColorDot'
import { Text, Localizer } from 'preact-i18n'
import Form from '../components/Form'
import TextInput from '../components/Form/TextInput'
import Button from '../components/Button'
import Select from '../components/Form/Select'
import Checkbox from '../components/Form/Checkbox'
import Print from '../components/Print'
import { language } from '../config/config'
import { API_URL } from '../main'

const combine = (...functions) => x => {
    let result = x;
    for (let i = functions.length - 1; i >= 0; i--)
        result = functions[i](result)
    return result;
}

const formFields = {
    "anrede": {
        type: combine(Form.types.oneOf('herr', 'frau'), Form.types.required),
        default: '' // Doesn't need to be here - Just for reference
    }, 
    "lastName":           { type: Form.types.required },
    "firstName":          { type: Form.types.required },
    "company":            { type: Form.types.required },
    "position":           { type: Form.types.optional },
    "email":              { 
        type: combine(Form.types.email, Form.types.required) 
    },
    "phone":              { type: Form.types.optional },
    "street":             { type: Form.types.required },
    "plz_ort":            { type: Form.types.required },
    "accept_data_policy": { type: Form.types.mustAccept }
}

const anrede = [
    { key: '', value: 'form.anrede' },
    { key: 'frau', value: 'form.anredeOptions.frau' },
    { key: 'herr', value: 'form.anredeOptions.herr' }
]

export default class Summary extends Component {
    constructor(props) {
        super(props);
        
        this.updateFormData = formData => this.props.setState({formData})
    }

    render ({state: {shade, cable, mount, formData}, goto}) {
        return (
            <div class="limba__summary container">
                <Headline />
                <div class="limba__konfiguration">
                    <div class="row">
                        <div class="col-sm-12 col-md-6 order-2">
                            <Product cable={cable} shade={shade} mount={mount} />
                        </div>
                        <div class="col-sm-12 col-md-6 order-1">
                            <h3><strong><Text id="konfiguration.headline" /></strong></h3>
                            <table class="limba__summary__table">
                                <tr>
                                    <th><Text id="parts.shade" /></th>
                                    <td>
                                        <b><Text id={"shade.color." + shade.color} /></b>
                                        <ColorDot color={'#' + shade.hexcolor} material={shade.material} label={"shade.color." + shade.color} />
                                    </td>
                                </tr> 
                                <tr>
                                    <th><Text id="parts.cable" /></th>
                                    <td>
                                        <b><Text id={"cable.color." + cable.color} /></b>
                                        <ColorDot color={'#' + cable.hexcolor} pattern={cable.pattern} />
                                    </td>
                                </tr>
                                <tr>
                                    <th><Text id="parts.mount" /></th>
                                    <td>
                                        <b><Text id={"mount.type." + mount.type} />{" "}| <Text id={"mount.color." + mount.color} /></b>
                                        <ColorDot color={'#' + mount.hexcolor} />
                                    </td>
                                </tr>
                            </table>
                            <div class="limba__controls-prev limba__controls--half">
                                <Button onClick={() => goto('chooseMount')}><Text id="controls.prev" /><span class="konf-icon-Arrow-OutLeft"></span></Button>
                            </div>
                            <Print mount={mount} cable={cable} shade={shade} />
                        </div>
                    </div>
                </div>
                <hr />
                <Form fields={formFields} data={formData} additionalData={{
                    mount: mount.id,
                    cable: cable.id,
                    shade: shade.id
                }} onChange={this.updateFormData} onReset={() => goto('chooseColor')} action={`${API_URL}/submit.php?lang=${language}`}>
                    <div class="row">
                        <div class="col-md-12">
                            <h3>
                                <strong><Text id="form.headline" /></strong><br/>
                                <strong><Text id="form.subline" /></strong>
                            </h3>
                            <p><Text id="form.text" /></p>
                        </div>
                    </div>
                    <div class="row mt-4">
                        <div class="col-12 col-md-6">
                            <Select name="anrede" label="form.anrede" options={anrede} required />
                        </div>
                        <div class="w-100" />
                        <div class="col-12 col-md-6">
                            <TextInput name="lastName" label="form.lastName" required />
                        </div>
                        <div class="col-12 col-md-6">
                            <TextInput name="firstName" label="form.firstName" required />
                        </div>
                        <div class="w-100" />
                        <div class="col-12 col-md-6">
                            <TextInput name="company" label="form.company" required />
                        </div>
                        <div class="col-12 col-md-6">
                            <TextInput name="position" label="form.position" />
                        </div>
                        <div class="w-100" />
                        <div class="col-12 col-md-6">
                            <TextInput name="email" label="form.email" required />
                        </div>
                        <div class="col-12 col-md-6">
                            <TextInput name="phone" label="form.phone" />
                        </div>
                        <div class="w-100" />
                        <div class="col-12 col-md-6">
                            <TextInput name="street" label="form.street" required />
                        </div>
                        <div class="col-12 col-md-6">
                            <TextInput name="plz_ort" label="form.plz_ort" required />
                        </div>
                        <div class="col-12">
                            <Checkbox name="accept_data_policy" required>
                                <Text id="form.accept_privacy" /> <Localizer><a href={<Text id="form.accept_privacy_link" />} target="_blank"><Text id="form.accept_privacy_text" /></a></Localizer>
                            </Checkbox>
                        </div>
                    </div>
                </Form>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./js/views/Summary.js